import React from 'react';
import { Helmet } from "react-helmet-async";
import HeaderFour from '../../components/Header/HeaderFour';
import FooterTwo from '../../components/Footer/FooterTwo';
import Breadcrumb from '../../components/Breadcrumb';
// import SectionTitle from '../../components/SectionTitle';
import SingleTeamThree from '../../components/Team/SingleTeamThree';

import teamImg1 from '../../assets/img/team/sudhirm.jpg';
import teamImg2 from '../../assets/img/team/Amrutha.jpg';
import teamImg3 from '../../assets/img/team/ramarao.jpg';
// import teamImg4 from '../../assets/img/team/Vimal.jpg';
import teamImg5 from '../../assets/img/team/Ananda.jpg';
// import teamImg6 from '../../assets/img/team/Ramakrishna.jpg';
import teamImg7 from '../../assets/img/team/Ravindranath.jpg';
import teamImg8 from '../../assets/img/team/Shyam.jpg';
// import teamImg9 from '../../assets/img/team/Akash.jpg';
// import teamImg10 from '../../assets/img/team/Karthik.jpg';
import teamImg11 from '../../assets/img/team/ventakapavan.jpg';
import teamImg12 from '../../assets/img/team/srinivas.jpg';
import teamImg13 from '../../assets/img/team/Uday.jpg';
import teamImg14 from '../../assets/img/team/pravin.jpg';
import teamImg15 from '../../assets/img/team/dharmesh.jpg';

const OurTeam = () => {
  return (
    <main>
      <Helmet>
        <meta charSet="utf-8" />
        {/* OLD TITLE COMMENTED */}
        {/* <title>Meet the Team at Central Books | Our Experts in Education</title> */}

        <title>
          Meet the Central Books Team | CBS HUB Hyderabad Education Experts
        </title>

        {/* OLD DESCRIPTION COMMENTED */}
        {/* <meta name="description" content="Get to know the dedicated professionals behind Central Books. Our team of over 250 experts is passionate about education and committed to delivering exceptional service to our clients." /> */}
        <meta  name="description" content="Meet the 250+ education professionals at CBS HUB Private Limited powering India's leading B2B school supply company across Hyderabad, Telangana, AP and beyond."
        />
        <meta  name="keywords" content="Central Books team, CBS HUB Hyderabad staff, education professionals, school supply experts India" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Central Books" />
        <meta httpEquiv="content-language" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://www.centralbooks.in/ourteam" />
        <meta property="og:title" content="Meet the Central Books Team | CBS HUB Hyderabad Education Experts" />
        <meta property="og:description"content="Meet the 250+ education professionals at CBS HUB Private Limited powering India's leading B2B school supply company across Hyderabad, Telangana, AP and beyond." />

        {/* OLD IMAGE COMMENTED */}
        {/* <meta property="og:image" content="https://www.centralbooks.in/images/team-photo.jpg" /> */}

        <meta  property="og:image" content="https://www.centralbooks.in/images/ourteam-og.jpg" />
        <meta property="og:url" content="https://www.centralbooks.in/ourteam" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Central Books" />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Meet the Central Books Team | CBS HUB Hyderabad Education Experts" />
        <meta name="twitter:description" content="Meet the 250+ education professionals at CBS HUB Private Limited powering India's leading B2B school supply company across Hyderabad, Telangana, AP and beyond."/>
        <meta name="twitter:image" content="https://www.centralbooks.in/images/ourteam-og.jpg" />
        {/* EXISTING ORGANIZATION SCHEMA KEPT */}
        <script type="application/ld+json">{JSON.stringify({"@context":"https://schema.org","@type":"Organization",name: "Central Books",url:"https://www.centralbooks.in/ourteam",logo:"https://centralbooks.in/static/media/logo-white.6970e86702604974eb88.png",})}
        </script>
        {/* NEW BREADCRUMB SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.centralbooks.in/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Meet Our Team",
                item: "https://www.centralbooks.in/ourteam",
              },
            ],
          })}
        </script>
      </Helmet>
      <HeaderFour />
      <Breadcrumb title="Our Team" />

      <div className="ed-team-area p-relative inner-style fix z-index pt-110 pb-90">
        <div className="container">
          {/* <div className="it-team-title-wrap mb-40">
            <div className="row align-items-center justify-content-center">
              <div className="col-xl-6">
                <SectionTitle
                  itemClass="it-team-title-box text-center"
                  subTitleClass="ed-section-subtitle"
                  subTitle="Promoters"
                  titleClass="ed-section-title"
                  title="Promoters"
                />
              </div>
            </div>
          </div> */}
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
              <SingleTeamThree
                teamImage={teamImg1}
                authorName="Sudhir Munagala"
                designation="Managing Director"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
              <SingleTeamThree
                teamImage={teamImg2}
                authorName="Amrutha Munagala"
                designation="Managing COO & IT Head"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
              <SingleTeamThree
                teamImage={teamImg3}
                authorName="Rama Rao Gunuganti"
                designation="Vice President - Sales | Telangana"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
              <SingleTeamThree
                teamImage={teamImg5}
                authorName="Ananda Krishnan"
                designation="Vice President Procurement"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
              <SingleTeamThree
                teamImage={teamImg7}
                authorName="Ravindranath Bandi"
                designation={
                  <>
                    Business Head<br />                    
                    Libraries & General Operations
                  </>
                }
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
              <SingleTeamThree
                teamImage={teamImg8}
                authorName="Shyam Mechineni"
                designation={
                  <>
                    Business Head<br />                    
                    Certified Examiner
                  </>
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
              <SingleTeamThree
                teamImage={teamImg11}
                authorName="Ventaka Pavan Kumar"
                designation={
                  <>
                    Supply Chain Manager<br />                    
                    - Hyderabad.
                  </>
                }
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
              <SingleTeamThree
                teamImage={teamImg12}
                authorName="M Srinivas"
                designation={
                  <>
                    Senior Supply Chain Manager<br />                    
                     - Online - Hyderabad.
                  </>
                }
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
              <SingleTeamThree
                teamImage={teamImg13}
                authorName="Uday Kumar"
                designation={
                  <>
                    Cluster Manager<br />                    
                    Retail
                  </>
                }
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
              <SingleTeamThree
                teamImage={teamImg14}
                authorName="Pravin William Dsouza"
                designation={
                  <>
                    Operations Head- <br />                    
                    SCM
                  </>
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
              <SingleTeamThree
                teamImage={teamImg15}
                authorName="Dharmesh Vrujilal Popat"
                designation={
                  <>
                    Vice President - <br />                    
                    West Sales & Marketing
                  </>
                }
              />
            </div>
          </div>
        </div>
      </div>
      <FooterTwo />
    </main>
  );
};
export default OurTeam;
